import { createFileRoute } from '@tanstack/react-router';
import { JourneysWizardStepHandoff } from '@/pages/workspaces/imports/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';
import { validateWizardSearch } from './-import-wizard-search';

/** The legacy upload URL. Flag off the embedded app renders; flag on it forwards to the migrated one. */
function JourneysImportUploadRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysWizardStepHandoff step="upload" />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/setup/')({
  validateSearch: validateWizardSearch,
  component: JourneysImportUploadRoute,
});
